<template>
<div>
  <title-header @to-services="toServices()" @to-contact="toContact()" @to-gallery="toGallery()" @to-map="toMap()" @to-budget="toBudget()" @to-start="toStart()"></title-header>
  <!--<services ref = "services"></services>
  <reviews></reviews>
  <contact ref = "map"> </contact>-->
  <router-view> </router-view>
  <page-footer> </page-footer>
</div>
</template>

<script>

import {store} from '../store.js';

import TitleHeader from './TitleHeader.vue'
import PageFooter from './Footer.vue'
//import Gallery from './Gallery.vue'

//import {router} from '../router/index.js'
export default {
  name: 'MasterPage',
  components: {
    TitleHeader,
    PageFooter
  },
  methods: {
    toServices: function() {
      store.commit('setRefToScroll', "services");
      this.$router.push('/');
    },
    toBudget: function() {
      this.$router.push('/budget')
    },
    toGallery: function() {
      this.$router.push('/gallery')
    },
    toMap: function(){
      // Si ya estaba en clientpage cambiar el valor en la store debería bastar
      store.commit('setRefToScroll', "map");
      if(!(this.$route.name == "ClientPage")){
        this.$router.push({ name: 'ClientPage'});
      }
    },
    toStart: function(){
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
  font-family: 'Century Gothic', 'Tahoma', 'Verdana'
}
</style>
